import React from "react";
import { Link } from "react-router-dom";
import { Applogo } from "../../../Routes/ImagePath";

const TermsAndConditions = () => {
  return (
    <div>
      <div className="account-page">
        <div className="main-wrapper">
          <div className="account-content">
            <div className="container">
              {/* Account Logo */}
              <div className="account-logo">
                <Link to="/">
                  <img src={Applogo} alt="Company Logo" />
                </Link>
              </div>
              {/* /Account Logo */}
              <div className="account-box" style={{ maxWidth: "800px" }}>
                <div className="account-wrapper">
                  <h3 className="account-title">Terms & Conditions</h3>
                  <p className="account-subtitle text-muted">
                    Last updated: April 2026
                  </p>

                  <div className="privacy-content mt-4" style={{ textAlign: "left" }}>
                    <section className="mb-4">
                      <h5 className="text-primary">1. Acceptance of Terms</h5>
                      <p>
                        By accessing and using the Prince Ebeano HR Management System ("App"),
                        you agree to be bound by these Terms and Conditions. If you do not agree
                        with any part of these terms, you must not use the App.
                      </p>
                    </section>

                    <section className="mb-4">
                      <h5 className="text-primary">2. Use of the Application</h5>
                      <p>
                        This App is provided exclusively for employees of Prince Ebeano Supermarket
                        for managing HR-related activities including but not limited to:
                      </p>
                      <ul>
                        <li>Attendance tracking and management</li>
                        <li>Leave request and approval workflows</li>
                        <li>Loan application and management</li>
                        <li>Payslip viewing and salary information</li>
                        <li>Employee profile and records management</li>
                      </ul>
                      <p>
                        You agree to use the App only for its intended purposes and in compliance
                        with all applicable company policies and regulations.
                      </p>
                    </section>

                    <section className="mb-4">
                      <h5 className="text-primary">3. User Accounts</h5>
                      <p>
                        You are responsible for maintaining the confidentiality of your account
                        credentials. You must notify your HR department immediately if you suspect
                        any unauthorized access to your account.
                      </p>
                      <ul>
                        <li>You may not share your login credentials with any other person</li>
                        <li>You may not allow others to access the App using your account</li>
                        <li>You are responsible for all activities that occur under your account</li>
                        <li>You must use a strong password and change it periodically</li>
                      </ul>
                    </section>

                    <section className="mb-4">
                      <h5 className="text-primary">4. Attendance & Biometric Data</h5>
                      <p>
                        The App may collect biometric data for attendance verification purposes.
                        By using the attendance features, you consent to the collection and
                        processing of this data in accordance with our{" "}
                        <Link to="/privacy-policy">Privacy Policy</Link>.
                      </p>
                      <p>
                        You must not attempt to manipulate or falsify attendance records. Any
                        attempt to do so may result in disciplinary action.
                      </p>
                    </section>

                    <section className="mb-4">
                      <h5 className="text-primary">5. Leave & Loan Requests</h5>
                      <p>
                        All leave and loan requests submitted through the App are subject to
                        approval by authorized personnel. Submission of a request does not
                        guarantee approval. You agree to:
                      </p>
                      <ul>
                        <li>Provide accurate information in all requests</li>
                        <li>Abide by company leave policies and procedures</li>
                        <li>Repay loans according to agreed-upon terms</li>
                        <li>Not submit fraudulent or misleading requests</li>
                      </ul>
                    </section>

                    <section className="mb-4">
                      <h5 className="text-primary">6. Data Accuracy</h5>
                      <p>
                        You are responsible for ensuring that all information you provide through
                        the App is accurate, complete, and up to date. The company reserves the
                        right to verify any information submitted and may take disciplinary action
                        for deliberate submission of false information.
                      </p>
                    </section>

                    <section className="mb-4">
                      <h5 className="text-primary">7. Intellectual Property</h5>
                      <p>
                        All content, features, and functionality of the App, including but not
                        limited to text, graphics, logos, icons, software, and design, are owned
                        by Prince Ebeano Supermarket and are protected by applicable intellectual
                        property laws. You may not:
                      </p>
                      <ul>
                        <li>Copy, modify, or distribute any part of the App</li>
                        <li>Reverse engineer or decompile the App software</li>
                        <li>Use the App's content for any commercial purpose outside of employment</li>
                        <li>Remove any copyright or proprietary notices from the App</li>
                      </ul>
                    </section>

                    <section className="mb-4">
                      <h5 className="text-primary">8. Acceptable Use</h5>
                      <p>You agree not to:</p>
                      <ul>
                        <li>Use the App for any unlawful purpose</li>
                        <li>Attempt to gain unauthorized access to any part of the system</li>
                        <li>Interfere with or disrupt the App's functionality</li>
                        <li>Upload any malicious software or content</li>
                        <li>Use the App to harass or discriminate against other employees</li>
                      </ul>
                    </section>

                    <section className="mb-4">
                      <h5 className="text-primary">9. Limitation of Liability</h5>
                      <p>
                        The App is provided "as is" without warranties of any kind, either express
                        or implied. Prince Ebeano Supermarket shall not be liable for any indirect,
                        incidental, special, or consequential damages arising from your use of the
                        App, including but not limited to:
                      </p>
                      <ul>
                        <li>Loss of data or information</li>
                        <li>System downtime or interruptions</li>
                        <li>Errors in calculations or processing</li>
                        <li>Unauthorized access to your account</li>
                      </ul>
                    </section>

                    <section className="mb-4">
                      <h5 className="text-primary">10. Termination</h5>
                      <p>
                        Access to the App may be terminated or suspended at any time upon
                        termination of employment or at the discretion of the company. Upon
                        termination, you must cease all use of the App and any data accessed
                        through it.
                      </p>
                    </section>

                    <section className="mb-4">
                      <h5 className="text-primary">11. Changes to Terms</h5>
                      <p>
                        We reserve the right to modify these Terms and Conditions at any time.
                        Significant changes will be communicated through the App or company
                        communication channels. Continued use of the App after changes constitutes
                        acceptance of the updated terms.
                      </p>
                    </section>

                    <section className="mb-4">
                      <h5 className="text-primary">12. Governing Law</h5>
                      <p>
                        These Terms and Conditions shall be governed by and construed in accordance
                        with the laws of the Federal Republic of Nigeria. Any disputes arising
                        from these terms shall be resolved through the company's internal dispute
                        resolution mechanisms.
                      </p>
                    </section>

                    <section className="mb-4">
                      <h5 className="text-primary">13. Contact Us</h5>
                      <p>
                        If you have any questions about these Terms and Conditions, please contact:
                      </p>
                      <ul className="list-unstyled">
                        <li><strong>HR Department</strong></li>
                        <li>Prince Ebeano Supermarket</li>
                        <li>Email: hr@princeebeano.com</li>
                      </ul>
                    </section>
                  </div>

                  <div className="account-footer mt-4">
                    <p>
                      <Link to="/" className="btn btn-primary">
                        Back to Login
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
